import React, { useCallback, useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import { defineMessages, FormattedMessage } from "react-intl";
import { generateBase58uuid } from "../utils";

const messages = defineMessages({
  menuTooltipClose: {
    id: "app.entityForm.menuTooltipClose",
    description: "close menu",
    defaultMessage: "close menu",
  },
  menuTooltipOpen: {
    id: "app.entityForm.menuTooltipOpen",
    description: "open menu",
    defaultMessage: "open menu",
  },
});

const StyledMenu = styled.div`
  align-self: flex-start;
  position: sticky;
  top: 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  user-select: none;
  & a {
    color: ${({ theme }) => theme.regularTextColor};
    font-weight: 600;
  }
  & a:hover {
    color: ${({ theme }) => theme.buttonColorLight};
  }
  & a:focus {
    color: ${({ theme }) => theme.buttonColorLight};
  }
`;
const MenuButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  min-width: 40px;
  max-height: 40px;
  max-width: 40px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.buttonColorLight};
  margin-bottom: 5px;
  & em {
    color: white;
  }
`;

const StyledLink = styled(Link)`
  margin-top: 5px;
  display: flex;
`;

function Menu({ showMenu, fields, className }) {
  const [open, setOpen] = useState(false);
  const [sections, setSections] = useState([]);

  useEffect(() => {
    if (fields && fields.length && showMenu) {
      const sections = [];
      fields.forEach(field => {
        if (field.widget && field.widget === "section") {
          if (!field.menuIndex) {
            field.menuIndex = generateBase58uuid();
          }
          sections.push({ name: field.displayName, index: field.menuIndex });
        }
      });
      setSections(sections);
    }
  }, [fields, showMenu]);

  const handleOpen = useCallback(() => {
    setOpen(!open);
    ReactTooltip.hide();
  }, [open]);

  const menuTooltipClosed = (
    <ReactTooltip id="menu-tooltip-closed" delayShow={200}>
      <FormattedMessage {...messages.menuTooltipOpen} />
    </ReactTooltip>
  );

  const menuTooltipOpen = (
    <ReactTooltip id="menu-tooltip-open" delayShow={200}>
      <FormattedMessage {...messages.menuTooltipClose} />
    </ReactTooltip>
  );

  return (
    <StyledMenu className={className}>
      {open ? menuTooltipOpen : menuTooltipClosed}
      {open ? (
        <MenuButton onClick={handleOpen} data-tip="React-tooltip" data-for="menu-tooltip-open">
          <em className="fa  fa-2x  fa-angle-left" />
        </MenuButton>
      ) : (
        <MenuButton onClick={handleOpen} data-tip="React-tooltip" data-for="menu-tooltip-closed">
          <em className="fa  fa-2x  fa-bars" />
        </MenuButton>
      )}

      {open &&
        sections.map(section => (
          <StyledLink
            to={{
              hash: `#${section.index}`,
            }}>
            {section.name}
          </StyledLink>
        ))}
    </StyledMenu>
  );
}

export default Menu;
